import { createAction, props } from '@ngrx/store';
import { Dossier } from './dossier.model';

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record dossier',
    props<{id: string, signature: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record dossier success', 
    props<{ singleData: Dossier }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record dossier failure', 
    props<{ error: string }>()
);

// Pay all at once 
export const payAllAtOnce = createAction(
    '[Data] pay all at once dossier',
    props<{url: string}>()
);
export const payAllAtOnceSuccess = createAction(
    '[Data] pay all at once dossier success'
);
export const payAllAtOnceFail = createAction(
    '[Data] pay all at once dossier failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state dossier',
);